<template>
  <div>
    <div align="left">
      <br />
      <h5 class="font-weight-bold text-primary">Message Settings</h5>
      <br />
    </div>
    <b-card class="text-left">
      <b>Edit Message Settings</b>
      <br />
      <br />
      <b>GENERAL</b>
      <div v-if="loading">
        <b-spinner label="Spinning"></b-spinner>
      </div>
      <div v-else v-for="(input, k) in parameter" :key="k">
        <b-row align-v="center" class="mt-4">
          <b-col>
            <b-form-group
              id="fieldset-1"
              label="Key"
              label-class="control-label"
              class="required"
              label-for="input-1"
            >
              <input
                v-validate="'required'"
                v-model="input.key"
                :name="'key' + k"
                data-vv-as="Key"
                id="input-1"
                class="form-control"
                placeholder="Key"
              />
              <b-form-invalid-feedback id="input-key-feedback">{{
                veeErrors.first("key" + k)
              }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              id="fieldset-1"
              label="Value"
              label-class="control-label"
              class="required"
              label-for="input-1"
            >
              <input
                v-model="input.value"
                v-validate="'required'"
                :name="'value' + k"
                data-vv-as="Value"
                id="input-1"
                class="form-control"
                placeholder="Value"
              />
              <b-form-invalid-feedback id="input-value-feedback">{{
                veeErrors.first("value" + k)
              }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-link
              style="text-decoration: none"
              class="text-danger"
              @click="remove(k)"
              v-show="k || (!k && parameter.length > 1)"
            >
              <i class="far fa-trash-alt"></i> Remove
            </b-link>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="3">
            <b-button
              block
              variant="outline-primary"
              @click="add(k)"
              v-show="k == parameter.length - 1"
            >
              <i class="fas fa-plus"></i> Add More
            </b-button>
          </b-col>
        </b-row>
      </div>
      <div v-if="loading">
        <b-spinner label="Spinning"></b-spinner>
      </div>
      <div v-else v-for="(data, z) in parameters" :key="z">
        <b-row class="mt-5">
          <b-col md="4">
            <b>PHONE NUMBER</b>
            <b-form-input
              type="text"
              v-model="data.phone_display"
              v-validate="'required'"
              :name="'phone_display' + z"
              data-vv-as="Phone Number"
            >
            </b-form-input>
          </b-col>
          <b-col md="2">
            <b-form-checkbox
              v-model="data.is_enable"
              name="check-button"
              switch
              class="mt-4 pt-2"
            >
              <div v-if="data.is_enable" class="text-primary">Enabled</div>
              <div v-else style="color: #c4c7ca">Disabled</div>
            </b-form-checkbox>
          </b-col>
        </b-row>
        <div v-for="(input, k) in data.params" :key="k">
          <b-row align-v="center" class="mt-4">
            <b-col>
              <b-form-group
                id="fieldset-1"
                label="Key"
                label-class="control-label"
                class="required"
                label-for="input-1"
              >
                <input
                  v-model="input.key"
                  v-validate="'required'"
                  :name="'key' + k"
                  data-vv-as="Key"
                  id="input-1"
                  class="form-control"
                  placeholder="Key"
                />
                <b-form-invalid-feedback id="input-key-feedback">{{
                  veeErrors.first("key" + k)
                }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="fieldset-1"
                label="Value"
                label-class="control-label"
                class="required"
                label-for="input-1"
              >
                <input
                  v-if="input.key != 'whatsapp_private_key'"
                  v-model="input.value"
                  v-validate="'required'"
                  :name="'value' + k"
                  data-vv-as="Value"
                  id="input-1"
                  class="form-control"
                  placeholder="Value"
                />
                <b-form-textarea
                  v-else
                  id="textarea"
                  v-model="input.value"
                  v-validate="'required'"
                  :name="'value' + k"
                  data-vv-as="Value"
                  placeholder="Enter something..."
                  rows="3"
                  max-rows="6"
                ></b-form-textarea>

                <b-form-invalid-feedback id="input-value-feedback">{{
                  veeErrors.first("value" + k)
                }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-link
                style="text-decoration: none"
                class="text-danger"
                @click="removePhonePharam(z, k)"
                v-show="k || (!k && parameters[z].params.length > 1)"
              >
                <i class="far fa-trash-alt"></i> Remove
              </b-link>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3">
              <b-button
                block
                variant="outline-primary"
                @click="addPhonePharam(z, k)"
                v-show="k == parameters[z].params.length - 1"
              >
                <i class="fas fa-plus"></i> Add More
              </b-button>
            </b-col>
          </b-row>
        </div>
        <b-row>
          <b-col md="5">
            <b-button
              block
              variant="primary"
              @click="addPhone(z)"
              v-show="z == parameters.length - 1"
              class="mt-5"
            >
              <i class="fas fa-plus"></i> Add More Phone Number
            </b-button>
          </b-col>
        </b-row>
      </div>

      <b-row class="text-right">
        <b-col>
          <b-button
            variant="primary"
            :disabled="loading"
            @click="put()"
            class="mr-3"
            size="lg"
          >
            Save
            <b-spinner v-if="loading" small label="Loading..."></b-spinner>
          </b-button>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      settings: [],
      parameter: [
        {
          key: "",
          value: "",
        },
      ],
      parameters: [
        {
          is_enable: "",
          phone_display: "",
          params: [
            {
              key: "",
              value: "",
            },
          ],
        },
      ],
    };
  },
  mounted() {
    this.loading = true;
    this.$store
      .dispatch("MessageSettingsModule/getGeneralSettings")
      .then((response) => {
        this.loading = false;
        this.parameter = response.data.data.parameter_general;
        this.parameters = response.data.data.parameter_app;
      })
      .catch((error) => {
        this.loading = false;
        console.log(error);
      });
  },
  methods: {
    add(index) {
      this.parameter.push({
        key: "",
        value: "",
      });
    },
    addPhonePharam(index, data) {
      this.parameters[index].params.push({
        key: "",
        value: "",
      });
    },
    removePhonePharam(index, data) {
      this.parameters[index].params.splice(data, 1);
    },
    addPhone(index) {
      this.parameters.push({
        is_enable: false,
        phone_display: "",
        params: [
          {
            key: "",
            value: "",
          },
        ],
      });
    },
    remove(index) {
      this.parameter.splice(index, 1);
    },
    put() {
      this.$swal({
        title: "Are you sure?",
        text: "You will update this Message Settings!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, update it!",
      }).then((result) => {
        if (result.value) {
          this.$validator.validateAll().then((result) => {
            if (result) {
              this.loading = true;
              const formData = new FormData();
              if (this.parameter) {
                $.each(this.parameter, (index, value) => {
                  formData.append("parameter_general[sequences]", index);
                  formData.append(
                    `parameter_general[${index}][key]`,
                    value.key
                  );
                  formData.append(
                    `parameter_general[${index}][value]`,
                    value.value
                  );
                });
              }
              if (this.parameters) {
                $.each(this.parameters, (index, value) => {
                  formData.append("parameter_app[sequences]", index);
                  formData.append(
                    `parameter_app[${index}][phone_display]`,
                    value.phone_display
                  );
                  formData.append(
                    `parameter_app[${index}][is_enabled]`,
                    value.is_enable
                  );
                  $.each(value.params, (keys, data) => {
                    formData.append(
                      `parameter_app[${index}][params][sequences]`,
                      keys
                    );
                    formData.append(
                      `parameter_app[${index}][params][${keys}][key]`,
                      data.key
                    );
                    formData.append(
                      `parameter_app[${index}][params][${keys}][value]`,
                      data.value
                    );
                  });
                });
              }
              this.$store
                .dispatch("MessageSettingsModule/postGeneralSettings", formData)
                .then((response) => {
                  this.loading = false;
                  this.$swal({
                    type: "success",
                    title: "Your work has been saved",
                    showConfirmButton: false,
                    timer: 1500,
                  });
                  console.log(response);
                })
                .catch((error) => {
                  this.loading = false;
                  this.$swal({
                    type: "error",
                    title: "Oops...",
                    text: error.response,
                    showConfirmButton: false,
                    timer: 1500,
                  });
                  console.log(error);
                });
            } else {
              this.$swal("ERROR!", "Your file cant be submit.", "warning");
            }
          });
        }
      });
    },
  },
};
</script>

<style>
</style>